import * as React from 'react'
import { Snackbar } from '@material-ui/core'


type ToastProps = {
    message: string,
    open: boolean,
    autoClose: boolean,
    onClose?: () => void,
    toastType: number
}

const Toast = ({ onClose, message, open, autoClose }: ToastProps) => {


    const snackbarProp = () => {
        let props: { autoHideDuration: number | null, message: string } = {
            message,
            autoHideDuration: null
        }
        if (autoClose) {
            props = { ...props, autoHideDuration: 3000 }
        }
        return props
    }

    return <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration {...snackbarProp()} onClose={onClose} />
}

export default Toast